import { IntRange } from '../int-range/int-range';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ScaleQuestionRangeFeedback {
  public rangeScaleAnswer!: IntRange;

  public isCorrect!: boolean;

  public feedback!: string;

  public static fromDto(dto: any): ScaleQuestionRangeFeedback {
    const feedback: ScaleQuestionRangeFeedback =
      new ScaleQuestionRangeFeedback();
    feedback.rangeScaleAnswer = IntRange.fromDto(dto.rangeScaleAnswer);
    feedback.isCorrect = dto.isCorrect;
    feedback.feedback = dto.feedback;
    return feedback;
  }
}
